export class PhaseNamesConstant {
    public static readonly Collaboration: string = 'Collaboration';
    public static readonly QaReview : string = 'QA Review';
    public static readonly Formatting: string = 'Formatting';
    public static readonly InReview: string = 'In Review';
    public static readonly ReadyForApproval: string = 'Ready For Approval';
    public static readonly Approved: string = 'Approved';
    public static readonly Effective: string = 'Effective';
    public static readonly Archived: string = 'Archived';
    public static readonly Cancelled: string = 'Cancelled';
    public static readonly Obsolete : string = 'Obsolete';
    public static readonly ClientSignature : string = 'Client Signature';
}
